import { Button, TextField, Text } from '@chatsdet/ui';
import { SCHEDULE_PRESETS } from './presets';

export type SchedulePreview = { cron: string; description: string };

type Props = {
  text: string;
  onTextChange: (value: string) => void;
  preview: SchedulePreview | null;
  error: string | null;
  isParsing: boolean;
  isCreating: boolean;
  onPreview: () => void;
  onPresetSelect: (cron: string, description: string) => void;
  onCreateFromPreview: () => void;
};

export function ScheduleCadenceFields({
  text,
  onTextChange,
  preview,
  error,
  isParsing,
  isCreating,
  onPreview,
  onPresetSelect,
  onCreateFromPreview,
}: Props) {
  return (
    <div className="flex flex-col gap-5">
      <div>
        <Text size="sm" weight="medium" className="mb-2">
          Quick schedules
        </Text>
        <div className="flex flex-wrap gap-2">
          {SCHEDULE_PRESETS.map((preset) => (
            <Button
              key={preset.label}
              variant="secondary"
              size="sm"
              isPending={isCreating}
              onPress={() => onPresetSelect(preset.cron, preset.description)}
            >
              {preset.label}
            </Button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <Text size="sm" weight="medium">
          Describe a schedule
        </Text>
        <div className="flex items-end gap-2">
          <div className="flex-1">
            <TextField
              aria-label="Describe a schedule"
              placeholder="e.g. every weekday at 9am"
              value={text}
              onChange={(v) => onTextChange(v)}
            />
          </div>
          <Button
            variant="secondary"
            size="sm"
            onPress={onPreview}
            isPending={isParsing}
            isDisabled={!text.trim()}
          >
            Preview
          </Button>
        </div>

        {preview && (
          <div className="flex items-center justify-between gap-3 rounded-md border border-border bg-muted/30 px-3 py-2">
            <div className="min-w-0">
              <Text size="sm" weight="medium" className="truncate">
                {preview.description}
              </Text>
              <Text size="xs" className="text-muted-foreground font-mono">
                {preview.cron}
              </Text>
            </div>
            <Button variant="primary" size="sm" isPending={isCreating} onPress={onCreateFromPreview}>
              Create
            </Button>
          </div>
        )}

        {error && (
          <Text size="sm" className="text-destructive">
            {error}
          </Text>
        )}
      </div>
    </div>
  );
}
